/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Box, Text } from 'grommet';

import { StyledPre } from './styles';

export namespace EditNamePreview {
  export interface Props {
    firstName: string;
    lastName: string;
    partyId: string;
  }
}

export const EditNamePreview: React.FC<EditNamePreview.Props> = ({ firstName, lastName, partyId }) => (
  <Box direction="row" flex justify="between">
    <Text as="div">
      Full name:{' '}
      <Text id={`it-fullname-preview-${partyId}`} weight="bold">
        <StyledPre>
          {firstName} {lastName}
        </StyledPre>
      </Text>
    </Text>
    <Text as="div">
      Initials:{' '}
      <Text id={`it-initials-preview-${partyId}`} weight="bold">
        {firstName.charAt(0).toUpperCase()}
        {lastName.charAt(0).toUpperCase()}
      </Text>
    </Text>
  </Box>
);
